import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const BgFilterStyled = styled.div<T>`
  backdrop-filter: blur(10px);
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  max-width: initial;
  max-height: initial;
  color: white;
  display: flex;
  overflow-y: auto !important;
  & > div {
    ${({ rtl }) => (rtl ? 'direction:rtl;' : '')}
  }
`;
